


















































/* eslint-disable max-len */
import {
  defineComponent, reactive, toRefs, onBeforeMount, computed, ComputedRef,
} from '@vue/composition-api'
import { StudyCase } from '@/state/clientFlowtypes'
import Pod from '@/components/layouts/Pod.vue'
import PodCard from '@/components/layouts/PodCard.vue'
// import { getHumanDateFromUnixTimestamp } from '@/lib/utils/getHumanDateFromUnixTimeStamp'
// const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

/**
 * Formats date objects to string yyyy-mm-dd output
 * The 'en-CA' locale is a way to obtain the desired
 */
const formatDate = (dObj: Date | null) => {
  if (dObj === null) return null
  return dObj.toLocaleDateString('en-CA')
}

/**
 * Formats date objects to string yyyy-mm-dd output
 * The 'en-CA' locale is a way to obtain the desired
 */
const getTimeStampOrNull = (dObj: Date | null | undefined) => {
  if (dObj === null || dObj === undefined) return null
  return dObj.valueOf()
}

type State = {
  loading: boolean;
  editToggle: boolean;
}

const initialState: State = {
  loading: true,
  editToggle: false,
}

const tableConfig = {
  headers: [
    {
      text: 'userId',
      align: 'start',
      value: 'id',
      width: 90,
    },
    { text: 'attachedBy', value: 'attachedById', width: 90 },
    { text: 'consent', value: 'consent' },
    { text: 'attached', value: 'attachedTimestamp' },
    { text: 'dbUpdated', value: 'dbUpdatedTimestamp' },
    { text: 'note', value: 'adminNote' },
  ],
}

export default defineComponent({
  components: {
    Pod, PodCard,
  },
  props: {
    studyId: { type: String, default: '' },
  },

  setup(props, context) {
    // Set up state
    const state = reactive({ ...initialState })

    /** Reactive get cases from store
     * Convert the vue object to array of objects (the cases) because we need an array for our data table
     *
     * WORK-AROUND: For some reason vuetify data table does not sort date object properly
     * Therefore I need to add unix timestamps columns for each date columns
    */
    const cases: ComputedRef<unknown> = computed(() => {
      // Firestore will return an object with the cases id's as keys
      const casesObj = context.root.$store.getters['studyCases/all'] as StudyCase[]
      // We will convert it into an array of objects (cases)

      const casesArr: object[] = []
      // We will convert it into an array of client objects with the key as 'id' property

      // eslint-disable-next-line no-restricted-syntax
      for (const [, value] of Object.entries(casesObj)) {
        casesArr.push({
          ...value,
          attachedTimestamp: getTimeStampOrNull(value.attachedDate),
          dbUpdatedTimestamp: getTimeStampOrNull(value.dbUpdatedAt),
        })
      }
      //      const casesArr = Object.values(casesObj) as {id: string; createdAt: string}[]
      // As a workaround for vuetify data table not sorting date properly,
      // add a timestamp representation for date properties/columns, that we
      // need in the data table

      return casesArr
    })

    /*
    const openParticipantPage = (caseId: string) => {
      context.root.$router.push({ name: 'studyCase', params: { caseId, studyId: props.studyId } })
    }
    */

    /**
     * Wire the component to our vuex implementation, e.g. get the case
     * If the client is undefined, open a new channel (this is specific to
     * the vuex/firebase lib that we are using)
     * TODO: implement error handling, i.e. no access to firebase.
     */
    onBeforeMount(() => {
      // console.log('beforemout')
      // we need to clear out state before opening for a new client..
      // https://mesqueeb.github.io/vuex-easy-firestore/extra-features.html#variables-for-firestorepath-or-filters
      // todo: implement a clientId in the state and check if its new, before clearing out state
      context.root.$store.dispatch('studyCases/closeDBChannel', { clearModule: true })
      try {
        context.root.$store.dispatch('studyCases/openDBChannel', { pathVariables: { studyId: props.studyId } })
          .then(() => {
            state.loading = false
          })
      } catch (e) {
        state.loading = false
        // console.log('some error')
        // console.log(e)
        // TODO:  check the error. It might just be that the dbchanell is already open
      }
    })

    // Make stuff available for the template
    return {
      // from self
      tableConfig,
      ...toRefs(state),
      formatDate,
      props,
      cases,
    }
  },
})

